<template>
    <section class="section sec2">
        <div class="inner">
            <div class="titbox">
                <p class="m_txt1 center" style="font-size:14px;margin-top:10px;">
                    1등 당첨을 위한! 압도적인 솔루션!
                </p>
                <p class="m_txt1 center">
                    넘버 페이버드
                </p>
                <p class="m_txt2 center">
                    Number Favored가 처음이라면<br>
                    파격 혜택 놓치지 마세요!
                </p>
            </div>
            <div>
                <div class="textbox">
                    <img :src="`${$STATIC_URL}/user/img/main_2.png`">
                    <div style="margin-left: 16px;">
                        <p class="m_txt2 center">
                            年 구독 후 미 당첨 시
                        </p>
                        <p class="m_txt1">
                            100% 환불
                        </p>
                    </div>
                </div>
                <div class="textbox">
                    <img :src="`${$STATIC_URL}/user/img/main_1.png`">
                    <div style="margin-left: 16px;">
                        <p class="m_txt2 center">
                            구독 연장시 혜택
                        </p>
                        <p class="m_txt1">
                            50% 할인
                        </p>
                    </div>
                </div>
                <div>

                </div>
            </div>

        </div>
    </section>
</template>
<script setup>

</script>

<style scoped>
.textbox {
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.12);
    margin-top: 16px;
    border-radius: 16px;
    padding-top: 16px;
    padding-bottom: 16px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    align-items: center;
}
</style>